import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUserRole } from './UserRoleProvider';

// The agency redirect tool (WIPE-1760). Open to admins and to holders of the `agency-redirect-admin`
// grant, the marketing staff who handle agency sales and renames without being admins. The API enforces
// the same rule as the 'AgencyRedirects' capability, so this guard is about not showing someone a page
// whose every call would 403; it is not the security boundary.
const AgencyRedirectRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { canManageAgencyRedirects, isLoading, rolesUnknown } = useUserRole();

  // The profile lookup failed, so we don't know whether access was granted — say so rather than
  // redirect, which would read as a denial to someone who does have it.
  if (rolesUnknown) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message">
            <p>We couldn't confirm your access. Please reload the page or sign in again.</p>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="page">
        <div className="page-content">
          <div className="loading-message"><p>Checking access...</p></div>
        </div>
      </div>
    );
  }

  if (!canManageAgencyRedirects) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AgencyRedirectRoute;
